module.exports = __webpack_public_path__ + "static/img/school-12.d531a44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-12.png
// module id = F7tB
// module chunks = 0